import { useContext } from 'react';
import { AnnotationLabelsContext } from '../AnnotationLabelsContext';

export const useAnnotationLabelsContext = () => {
  const context = useContext(AnnotationLabelsContext);
  if (!context) {
    throw new Error('useAnnotationLabelsContext must be used within an AnnotationLabelsContext.Provider');
  }
  return context;
};
